import { get } from 'lodash';
import moment from 'moment/moment';
import {
  FaEdit,
  FaRegFilePdf,
  FaRegFileWord,
  FaRegFilePowerpoint,
  FaRegFileImage,
  FaDownload,
  FaRegTrashAlt,
} from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { DELETE_NOTES } from '../../apiConst';
import { deleteRequest } from '../interceptor/interceptor';
import { toast } from 'react-toastify';

const setImageOrPdf = (uploadFile, uploadFileName, noteId, signedUrls) => {
  const fileExtension = uploadFile.split('.').pop().toLowerCase();
  const matchedUrl = signedUrls?.find(
    (urlObj) => urlObj?.key === uploadFileName
  );
  const imageUrl = matchedUrl ? matchedUrl.url : uploadFile;
  return (
    <div className="flex flex-row justify-between ">
      <div>
        {fileExtension === 'pdf' ? (
          <FaRegFilePdf className="text-5xl text-red-600" />
        ) : fileExtension === 'jpg' ||
          fileExtension === 'jpeg' ||
          fileExtension === 'png' ||
          fileExtension === 'gif' ? (
          <FaRegFileImage className="text-2xl text-blue-500" />
        ) : fileExtension === 'doc' || fileExtension === 'docx' ? (
          <FaRegFileWord className="text-2xl text-blue-500" />
        ) : fileExtension === 'pptx' ? (
          <FaRegFilePowerpoint className="text-2xl text-blue-500" />
        ) : null}
      </div>
      <div>
        {fileExtension === 'jpg' ||
        fileExtension === 'jpeg' ||
        fileExtension === 'png' ||
        fileExtension === 'gif' ? (
          <div className="flex flex-row justify-between ">
            <img src={imageUrl} key={uploadFileName} width="100px" alt="img" />{' '}
            <FaDownload
              className="ml-2 text-xl text-blue-500 cursor-pointer"
              onClick={() => window.open(imageUrl)}
            />
          </div>
        ) : (
          <div className="flex flex-row justify-between gap-2">
            {' '}
            {uploadFileName}{' '}
            <FaDownload
              className="ml-2 text-xl text-blue-500 cursor-pointer"
              onClick={() => window.open(imageUrl)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const NotesDisplay = ({
  notesData,
  onEditNote,
  type,
  isView,
  signedUrls,
  fetchNotes,
}) => {
  console.log('🚀 ~ signedUrls:', signedUrls);
  console.log('notesData', notesData);
  const { user } = useSelector((state) => state);
  const onRemoveFile = async (e, note) => {
    const res = await deleteRequest(`${DELETE_NOTES}${note}`);
    try {
      console.log('🚀 ~ onRemoveFile ~ res:', res);
      if (res) {
        toast.success(res?.data?.message);
        fetchNotes();
      }
    } catch (error) {
      console.log('🚀 ~ onRemoveFile ~ error:', error);
    }
  };

  return (
    <>
      {notesData &&
        notesData.length > 0 &&
        notesData.map((singleNote) => {
          console.log('singleNote', singleNote);
          return (
            <>
              <div className="ml-5">
                <div className="flex text-blue-500 font-semibold">
                  <div className="mr-2">
                    &#8226; {singleNote?.createdByEmail}
                  </div>

                  <div className="mx-2">
                    ({moment(singleNote.createdAt).format('DD-MM-YYYY, h:mm a')}
                    )
                  </div>
                </div>
                {type === 'dailyNotes' ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: singleNote.note,
                    }}
                    className="flex justify-center"
                  />
                ) : (
                  <div className="font-semibold">- {singleNote?.comment}</div>
                )}
                <div className="flex flex-row">
                  {singleNote?.attachment[0]?.url &&
                    // singleNote.uploadFileName &&
                    setImageOrPdf(
                      singleNote?.attachment[0]?.url,
                      singleNote?.attachment[0]?.key,
                      singleNote?.noteId,
                      signedUrls
                    )}
                  <FaRegTrashAlt
                    className="ml-2 text-xl text-red-500 cursor-pointer"
                    onClick={(e) => onRemoveFile(e, singleNote?.noteId)}
                  />
                </div>
              </div>
              {onEditNote && singleNote?.createdBy === user?.userId && (
                <div className="flex justify-end items-end md:items-center md:justify-center text-xl mr-10">
                  {!isView && (
                    <div
                      className="hover:text-blue-700 cursor-pointer"
                      onClick={(e) => onEditNote(e, singleNote)}
                    >
                      <FaEdit />
                    </div>
                  )}
                </div>
              )}
            </>
          );
        })}
    </>
  );
};

export default NotesDisplay;
